import {Tag} from '~/rest-client/servers/chipcore/enum'
import {translations} from '~/helpers/functions/translations'

const names = {
  ru: {
    gb: 'ГБ',
    GHz: 'ГГц'
  },
  en: {
    gb: 'GB',
    GHz: 'GHz'
  }
}

export default {
  data() {
    return {
      names
    }
  },
  methods: {
    addAdditionalData(servers) {
      return servers.map(server => {
        const {available} = server

        server.config = {
          cpu: this.getCpu(server.cpu),
          disk: this.getDisk(server.disk),
          gpu: this.getGpu(server.gpu),
          ram: this.getRam(server.ram)
        }

        if (server.tags && server.tags.length > 0) {
          server.hasHWRAID = server.tags.some(tag => tag === Tag.HWRAID)
          server.hasVROC = server.tags.some(tag => tag === Tag.VROC)
          server.hasTWOPSU = server.tags.some(tag => tag === Tag.TWO_PSU)
        }

        server.isAvailable = server.isPreorder || (server.isOrder && this.getAvailable(available))

        return server
      })
    },
    getAvailable(available) {
      return available.reduce((isAvailable, available) => {
        return isAvailable || !!available.count
      }, false)
    },

    getCount(count) {
      return count > 1
        ? `${count} x `
        : ''
    },

    getCpu(cpu) {
      const count = this.getCount(cpu.count)
      const {name} = cpu
      const baseFreq = `${cpu.baseFreq} ${this.names[this.$i18n.locale].GHz}`
      const cores = cpu.count * cpu.coresPerCpu

      return {
        name: `${count}${name}`,
        params: `${baseFreq}, ${translations.coresAmount[this.$i18n.locale]({count: cores})}`,
        full: `${count}${name} ${baseFreq}, ${translations.coresAmount[this.$i18n.locale]({count: cores})}`
      }
    },

    getDisk(disk) {
      return disk.map(disk => {
        return `${this.getCount(disk.count)}${disk.size} ${this.names[this.$i18n.locale].gb} ${disk.type}`
      })
        .join(' + ')
    },

    getGpu(gpu) {
      return `${this.getCount(gpu.count)}${gpu.name
        ? gpu.name
        : ''
      }`
    },

    getRam(ram) {
      return ram.map(ram => {
        return `${ram.size * ram.count} ${this.names[this.$i18n.locale].gb} ${ram.type}`
      })
        .join(' + ')
    }
  }
}